import { useQuery } from 'react-query';

import getDeliveryNotesFormats from '@/common/api/delivery-notes/getDeliveryNotesFormats';
import { ENDPOINT_DELIVERY_NOTES_FORMATS } from '@/common/constants';

const useDeliveryNotesFormats = () =>
  useQuery([ENDPOINT_DELIVERY_NOTES_FORMATS], getDeliveryNotesFormats);

export default useDeliveryNotesFormats;
